import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {map, mergeMap} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {MissingFieldForm} from '../entities/MissingFieldForm';
import {FormGroup, FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {OverlayComponent} from '../overlay/overlay.component';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-form',
  standalone: true,
  imports: [CommonModule, FormsModule, OverlayComponent],
  templateUrl: './form.component.html',
  styleUrl: './form.component.css'
})
export class FormComponent implements OnInit {

  missingFieldForm: MissingFieldForm | undefined = undefined;
  updateUrl: string | undefined = undefined;
  token: string | null = null;

  isLoading: boolean = true;

  isInputDisabled: boolean = false;

  isSent: boolean = false;

  mainFormGroup: FormGroup = new FormGroup({});

  constructor(
    private activatedRoute: ActivatedRoute,
    private httpClient: HttpClient
  ) {
  }

  ngOnInit() {

    this.activatedRoute
      .queryParamMap
      .pipe(map(queryParamMap => {

        this.token = queryParamMap.get('token');

        return this.token;
      }))
      .pipe(mergeMap(token => this.httpClient.get<any>(environment.apiUrl + '/form?token=' + token, {observe: 'response'})))
      .pipe(map(response => response.body))
      .subscribe(response => {

        this.missingFieldForm = MissingFieldForm.fromJson(response);
        this.updateUrl = response.operations.__update.__self;

        this.isLoading = false;
      });
  }

  private buildHttpHeaders() {

    return new HttpHeaders()
      .append('Content-Type', 'application/json');
  }

  isValid(): boolean {

    let isValid = true;

    this.missingFieldForm?.missingFields.map(missingField => {

      if(isValid) {

        if(missingField.fieldValue.length === 0) {

          isValid = false;
        }
      }
    });

    return isValid;
  }

  sendForm() {

    this.isLoading = true;

    if (this.updateUrl !== undefined && this.token !== null) {

      this.httpClient
        .post<any>(environment.apiUrl + '/form?token=' + this.token, this.missingFieldForm?.json(), {
          headers: this.buildHttpHeaders(),
          observe: 'response'
        })
        .subscribe(
          response => {

            this.isSent = true;
            this.isInputDisabled = true;
            this.isLoading = false;
          },
          error => {

            this.isSent = true;
            this.isInputDisabled = true;
            this.isLoading = false;
            console.error(error);
          }
        );
    }
  }
}
